import React from "react";
import {Link} from "react-router";
import { geocodeAndSave, hasValidCoords, canGeocode } from "../../utils/geocode";

/** Places the property, or tells the user why it has no map point. */
export async function placeOrSay(property) {
    try {
        const placed = await geocodeAndSave(property);
        if (!placed) {
            alert('This address could not be confirmed in its ZIP, so it has no map point. Check the address and ZIP.');
        }
        return placed;
    } catch (error) {
        alert('The map point could not be looked up: ' + error.message);
        return null;
    }
}

/** Opens the property on the parcel map in a new tab, placing it first when it has no map point yet. */
const ParcelMapLink = ({property, className, children}) => {
    const [isPlacing, setIsPlacing] = React.useState(false);
    const id = property.ARCIMEDES_ROW_ID;
    const hasCoords = hasValidCoords(property);
    const hasAddress = canGeocode(property);
    // The parcels view rather than the plain map, named by property rather
    // than by coordinates: a rooftop geocode a few metres out would otherwise
    // open the neighbouring parcel's card.
    const mapPath = arc.path.base + "map/parcels";
    const mapUrl = mapPath + "?property=" + id;

    const handleClick = async (e) => {
        if (hasCoords) return;
        if (!hasAddress) {
            e.preventDefault();
            alert('Cannot geocode: Address, City, or State is missing.');
            return;
        }
        e.preventDefault();
        setIsPlacing(true);
        const result = await placeOrSay(property);
        setIsPlacing(false);
        if (result) {
            window.open(mapUrl, '_blank');
        }
    };

    if (isPlacing) {
        return <span style={{display: 'inline-block', width: 16, height: 16, border: '2px solid #ccc', borderTopColor: '#333', borderRadius: '50%', animation: 'spin 1s linear infinite'}} />;
    }

    return (
        <Link className={className} target="_blank" to={{pathname: mapPath, query: {property: String(id)}}} onClick={handleClick}>
            {children}
        </Link>
    );
};

export default ParcelMapLink;
